import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pla-article-landing',
  templateUrl: './article-landing.component.html',
  styleUrls: ['./article-landing.component.scss']
})
export class ArticleLandingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
